import { render, staticRenderFns } from "./pageShare.vue?vue&type=template&id=120b9581&scoped=true&"
import script from "./pageShare.vue?vue&type=script&lang=js&"
export * from "./pageShare.vue?vue&type=script&lang=js&"
import style0 from "./pageShare.vue?vue&type=style&index=0&id=120b9581&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b9581",
  null
  
)

export default component.exports